export default __webpack_public_path__ + "static/media/clock.7757de3d.svg";